import { Button, Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { instanceRef } from '../../utils/axios';

function Aseguradora() {
  const history = useHistory();
  const [aseguradoraId, setAseguradoraId] = useState();

  useEffect(() => {
    const fetchAseguradoraId = async () => {
      const response = await instanceRef.instance.get(
        `/aseguradoras/get-aseguradora-from-request`
      );
      if (response.data?.data) {
        const { id } = response.data.data;
        setAseguradoraId(id);
      }
    };
    fetchAseguradoraId();
  }, []);

  const parametros = async () => {
    history.push(`/admin-aseguradora-parametros/${aseguradoraId}`);
  };

  const productos = async () => {
    history.push(`/admin-aseguradora-productos/${aseguradoraId}`);
  };
  const productosEmpresa = async () => {
    history.push(`/admin-aseguradoraempresaproducto/${aseguradoraId}`);
  };
  const usuariosEmpresa = async () => {
    history.push(`/admin-aseguradoraempresausuario/${aseguradoraId}`);
  };
  const planes = async () => {
    history.push(`/admin-aseguradora-planes/${aseguradoraId}`);
  };
  const asignar = async () => {
    history.push(`/admin-aseguradora-asignacion/${aseguradoraId}`);
  };
  const codigoagente = async () => {
    history.push(`/admin-aseguradora-codigoagente/${aseguradoraId}`);
  };

  const landing = async () => {
    history.push(`/admin-aseguradora-landing/${aseguradoraId}`);
  };

  const detener = async () => {
    history.push(`/admin-aseguradora-detener/${aseguradoraId}`);
  };

  const autorizacionAseguradora = async () => {
    history.push(`/autorizacion-config-aseguradora/${aseguradoraId}`);
  };

  const autorizacionAseguradoraEmpresa = async () => {
    history.push(`/autorizacion-config-aseguradora-empresa/${aseguradoraId}`);
  };

  // const coberturas = async () => {
  //   history.push(`/admin-aseguradora-coberturas/${aseguradora}`);
  // };

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Administración de la Aseguradora"
        style={{ textAlign: 'left' }}
        loading={!aseguradoraId}
      >
        {aseguradoraId && (
          <>
            <Button type="link" onClick={parametros}>
              Parámetros
            </Button>
            <br />
            <Button type="link" onClick={productos}>
              Productos
            </Button>
            <br />
            <Button type="link" onClick={productosEmpresa}>
              Productos de las empresas
            </Button>
            <br />
            <Button type="link" onClick={usuariosEmpresa}>
              Usuarios de las empresas
            </Button>
            <br />
            <Button type="link" onClick={codigoagente}>
              Configurar corredoras
            </Button>
            <br />
            <Button type="link" onClick={planes}>
              Configurar planes
            </Button>
            <br />
            <Button type="link" onClick={asignar}>
              Asignar planes
            </Button>
            <br />
            <Button type="link" onClick={landing}>
              Configurar landing
            </Button>
            <br />
            <Button type="link" onClick={detener}>
              Detener procesos por cierre
            </Button>
            <br />
            <Button type="link" onClick={autorizacionAseguradora}>
              Configurar autorizaciones
            </Button>

            <br />
            <Button type="link" onClick={autorizacionAseguradoraEmpresa}>
              Configurar autorizaciones de las empresas
            </Button>
          </>
        )}
      </Card>
    </ResponsiveContainer>
  );
}
export default Aseguradora;
